import { z } from 'zod';
import { AccountNumSchema, IsoDateSchema } from './primitives.js';

export const AccountTypeSchema = z.enum(['ASSET', 'LIABILITY', 'EQUITY', 'INCOME', 'EXPENSE']);

export const ChartAccountVersionedSchema = z.object({
  accountNum: AccountNumSchema,
  accountLib: z.string().min(1).max(200),
  accountType: AccountTypeSchema,
  assetId: z.number().int().positive().nullable(),
  parentNum: AccountNumSchema.nullable(),
  version: z.number().int().positive(),
  effectiveFrom: IsoDateSchema,
  deletedAt: z.number().int().nullable(),
  createdAt: z.number().int().nonnegative(),
});

export const CreateChartAccountRequestSchema = z.object({
  accountNum: AccountNumSchema,
  accountLib: z.string().min(1).max(200),
  accountType: AccountTypeSchema,
  assetId: z.number().int().positive().nullable(),
  parentNum: AccountNumSchema.nullable(),
  effectiveFrom: IsoDateSchema,
});

export const DeleteChartAccountRequestSchema = z.object({
  effectiveFrom: IsoDateSchema,
});

export type ChartAccountVersionedDto = z.infer<typeof ChartAccountVersionedSchema>;
export type CreateChartAccountRequest = z.infer<typeof CreateChartAccountRequestSchema>;
export type AccountTypeDto = z.infer<typeof AccountTypeSchema>;
